// extracted by mini-css-extract-plugin
export var box = "_9b-1";
export var checked = "_9b-2";
export var descriptionSpacer = "_9b-9";
export var disabled = "_9b-3";
export var icon = "_9b-6";
export var input = "_9b-0";
export var labelSpacer = "_9b-8";
export var medium = "_9b-5";
export var small = "_9b-4";
export var text = "_9b-7";